<template>
	<el-main>
		<SolutionBanner :dataimgs="dataimgs" />
		<SolutionMain :data="solutionMains" />
	</el-main>
</template>

<script>
	import SolutionBanner from './SolutionBanner'
	import SolutionMain from './SolutionMain'
	export default {
		name: 'SolutionIndustry',
		components: {
			SolutionBanner,
			SolutionMain
		},
		data() {
			return {
				dataimgs: [{
					src1: require('@/assets/images/zhinengbanner.jpg'),
					src2: require('@/assets/images/zhinengbanner-m.png'),
					title: '工业智能制造解决方案',
					content: ['智能时代下的工业数据端到端解决方案', '从海量数据可视化分析中洞察商机，助力企业数字化转型'],
					btn: '立即咨询',
					url: 'http://wpa.qq.com/msgrd?v=3&uin=2629198267&site=qq&menu=yes'
				}],
				solutionMains: [{
					id: 0,
					title: '方案概述',
					contents: [{
						content: [
							'MoPaaS工业智能制造解决方案支持各种工业设备接入、集成各类工业应用服务，构建良性工业生态体系，使制造管理更加便捷高效。平台提供涵盖IaaS、DaaS、PaaS和SaaS的完整工业互联网服务功能，适合不同层次、类型、规模的企业；并且还可提供包括设备安全、网络安全、控制安全、应用安全、数据安全和商业安全的工业互联网完整安全保障体系。'
						]
					}],
				}, {
					id: 1,
					title: '方案架构',
					contents: [{
						content: ['MoPaaS工业智能制造解决方案为用户打造了以工业大数据为驱动，以云计算、大数据、物联网技术为核心的工业互联网开放平台，可以实现产品、机器、数据、人的全面互联互通和综合集成。']
					}, {
						title: '核心架构功能设计包括：',
						content: ['CloudFoundry平台增强功能<br/>容器平台功能<br/>工业大数据服务<br/>人工智能服务<br/>可扩展能力']
					}],
					src: require('@/assets/images/zhineng.png')
				}]
			}
		}
	}
</script>

<style>

</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SolutionIndustry.vue